import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, fontSizes }: Theme) => ({
  root: {},
  menuBox: {
    minWidth: 280,
    paddingTop: '0.375rem',
    paddingBottom: '0.375rem',
  },
  menuPaper: {
    top: '56px !important',
    borderRadius: '0.5rem',
    boxShadow: '3px 4px 13px 0 rgba(5, 41, 103, 0.1)',
    [breakpoints.down('sm')]: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      width: '100%',
      maxWidth: '100%',
      left: '0 !important',
      top: '80px !important',
      boxShadow: '0 8px 16px -8px rgba(5, 41, 103, 0.1)',
    },
    '&&': {
      maxHeight: 'calc(100% - 96px)',
    },
  },
  menuItemIconRoot: {
    '&&': {
      minWidth: 0,
      marginRight: 4,
    },
  },
  menuListItem: {
    minWidth: 'unset',
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: fontSizes.sm,
    lineHeight: 1.5,
    '& .MuiTypography-root': {
      minWidth: 'unset',
      background: 'transparent',
    },
  },
  menuInnerText: {
    [breakpoints.down('sm')]: {
      flex: '0 1 auto',
    },
    '& .MuiTypography-root': {
      fontSize: 'inherit',
      lineHeight: 'inherit',
    },
  },
}));
